import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgArrowDown = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: "13px",
	height: "8px",
	viewBox: "0 0 13 8",
	xmlns: "http://www.w3.org/2000/svg",
	xmlnsXlink: "http://www.w3.org/1999/xlink",
	...props,
	children: [
		/* @__PURE__ */ _jsx("title", { children: "arrow-down" }),
		/* @__PURE__ */ _jsx("desc", { children: "Created with Sketch." }),
		/* @__PURE__ */ _jsx("g", {
			id: "Page-1",
			stroke: "none",
			strokeWidth: 1,
			fill: "none",
			fillRule: "evenodd",
			children: /* @__PURE__ */ _jsx("g", {
				id: "arrow-down",
				transform: "translate(1.000000, 1.000000)",
				fill: "#111111",
				fillRule: "nonzero",
				children: /* @__PURE__ */ _jsx("path", {
					d: "M1.9839921,-2.97300724 C2.21910332,-3.2294922 2.60128014,-3.27073486 2.88311721,-3.08597846 L2.97300724,-3.0160079 L8.97300724,2.4839921 C9.24814998,2.73620628 9.27316296,3.15346923 9.04804617,3.43569227 L8.97300724,3.5160079 L2.97300724,9.0160079 C2.68802395,9.27724258 2.24522679,9.25799053 1.9839921,8.97300724 C1.74888089,8.71652228 1.74096392,8.33220808 1.94948446,8.06747001 L2.02699276,7.9839921 L7.462,3 L2.02699276,-1.9839921 C1.7705078,-2.21910332 1.72926514,-2.60128014 1.91402154,-2.88311721 L1.9839921,-2.97300724 Z",
					id: "Path",
					transform: "translate(5.499998, 3.000000) rotate(90.000000) translate(-5.499998, -3.000000) "
				})
			})
		})
	]
});
export default SvgArrowDown;
